import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import CreateFolderDialog from "../../dialog/createFolderDialog/CreateFolderDialog";
import { Dispatch, SetStateAction, useState } from "react";
import { IAdminDocument } from "../../../../../../@types/documentAdmnstration.types";

const CreateFolderButton = ({
	parent_folder_id,
	root_folder_id,
	documentList,
	setDocumentList
}: {
	parent_folder_id: string;
	root_folder_id: string;
	documentList: IAdminDocument[];
	setDocumentList: Dispatch<SetStateAction<IAdminDocument[]>>;
}) => {
	const [open, setOpen] = useState<boolean>(false);
	const handleOpen = () => {
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
	};
	return (
		<div>
			<label htmlFor="contained-button-file">
				<Button variant="contained" className="button-black" startIcon={<AddIcon />} onClick={handleOpen}>
					Create Folder
				</Button>
			</label>
			<CreateFolderDialog
				parent_folder_id={parent_folder_id}
				documentList={documentList}
				setDocumentList={setDocumentList}
				root_folder_id={root_folder_id}
				handleClose={handleClose}
				open={open}
				key={0}
			/>
		</div>
	);
};

export default CreateFolderButton;
